/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class MembershipProductsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Retrieve a list of all membership products which an existing customer can switch to
     */
    public all(__unused?: any): Observable<PagedArray<models.ApiMembershipProduct>> {
        const path = '/membership/products';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiMembershipProduct>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get a membership product
     * @param id 
     */
    public get(id?: number, __unused?: any): Observable<models.ApiMembershipProduct> {
        const path = '/membership/products/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiMembershipProduct>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
